module.exports = __webpack_public_path__ + "img/cvf.41a4ef42.svg";